import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export function Hero({
  text
}) {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      "data-test-id": "hero-section",
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFF1EE',
        border: '1px dashed #E66E50',
        height: 430,
        marginBottom: 40
      },
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: text
      })
    })
  );
}